import React from 'react'

const Filter = () => {
    return (
        <div className="col-lg-2">
            left filet
        </div>
    )
}

export default Filter
